/**
 * Enumération des recherches possible par le composant Search
 */
enum SearchStrategyEnum{
    INodeSearch,
    IShortMeterSearch,
    IShortLBOSearch
}

export default SearchStrategyEnum;